export const featuredProperties = [
  {
    id: 1,
    title: "Amwaj 4 - JBR",
    location: "Amwaj 4, JBR, Dubai",
    // price: "$4,250,000",
    bedrooms: 2,
    cars: 1,
    sqft: 1278,
    image: "/images/realty/1.jpg",
  },
  {
    id: 2,
    title: "Murjan 5 - JBR",
    location: "Murjan 5, JBR, Dubai",
    // price: "$2,750,000",
    bedrooms: 2,
    cars: 1,
    sqft: 1396,
    image: "/images/realty/2.jpg",
  },
  {
    id: 3,
    title: "Rimal 3 - JBR",
    location: "Rimal 3, JBR, Dubai",
    // price: "$1,950,000",
    bedrooms: 2,
    cars: 1,
    sqft: 1243,
    image: "/images/realty/3.jpg",
  },
  {
    id: 4,
    title: "Classic Brownstone Townhouse",
    location: "Boston, Massachusetts",
    price: "$3,150,000",
    bedrooms: 4,
    bathrooms: 3.5,
    sqft: 3600,
    image: "/images/realty/1.jpg",
  },
];

export const services = [
  {
    id: 1,
    title: "Residential Sales",
    description:
      "Find your dream home with our expert guidance from search to closing.",
    icon: "Home",
  },
  {
    id: 2,
    title: "Commercial Leasing",
    description:
      "Secure the perfect space for your business with our commercial property specialists.",
    icon: "Building2",
  },
  {
    id: 3,
    title: "Investment Advisory",
    description:
      "Maximize your real estate portfolio with data-driven investment strategies.",
    icon: "TrendingUp",
  },
  {
    id: 4,
    title: "Property Management",
    description:
      "Comprehensive management services to protect and enhance your property value.",
    icon: "ClipboardList",
  },
  {
    id: 5,
    title: "Global Real Estate Consulting",
    description:
      "Navigate international real estate markets with our global expertise.",
    icon: "Globe",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Kathie Corl",
    role: "Dubai, UAE",
    quote: "Exceptional service, unmatched real estate opportunities in UAE.",
    description:
      "Scan Realty made buying my first home easy and stress-free. Their team was professional, attentive, and found the perfect place for me. Highly recommended!",
    image: "/images/realty/user1.png",
  },
  {
    id: 2,
    name: "Matt Cannon",
    role: "Dubai, UAE",
    quote: "Ultimate real estate hub, unmatched quality and service.",
    description:
      "The team at Scan Realty was amazing. They sold our home fast and for a great price, handling everything with professionalism. We couldn't be happier!",
    image: "/images/realty/user2.png",
  },
  {
    id: 3,
    name: "Andy Smith",
    role: "Dubai, UAE",
    description:
      "Buying an investment property with Scan Realty was a breeze. They provided clear guidance, and the entire process was quick and smooth. Great experience overall!",
    quote: "Navigating properties made easy, unbeatable UAE options.",
    image: "/images/realty/user3.png",
  },
];

export const blogPosts = [
  {
    id: 1,
    title: "Rimal 3 - JBR",
    excerpt: "Rimal 3, JBR, Dubai",
    // date: "May 15, 2025",
    image: "/images/realty/1.jpg",
    category: "For sale",
  },
  {
    id: 2,
    title: "Murjan 5 - JBR",
    excerpt: "Murjan 5, JBR, Dubai",
    // date: "April 28, 2025",
    image: "/images/realty/2.jpg",
    category: "For sale",
  },
  {
    id: 3,
    title: "Amwaj 4 - JBR",
    excerpt: "Amwaj 4, JBR, Dubai",
    // date: "April 10, 2025",
    image: "/images/realty/3.jpg",
    category: "For sale",
  },
  {
    id: 4,
    title: "Damac Paramount (Tower B)",
    excerpt: "Damac Paramount (Tower B), Business Bay, Dubai",
    // date: "April 10, 2025",
    image: "/images/realty/5.jpg",
    category: "For sale",
  },
];
